import * as React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import useRoot from 'hooks/use-root';
import useAuth from 'features/auth/hooks/use-auth';
import { PropsWithChildren } from 'react';

const PublicRoute: React.FC<PropsWithChildren> = (props) => {
  const { state } = useAuth();
  const { defaultPage } = useRoot();
  const location = useLocation();

  const from = (location.state as { from?: string })?.from || defaultPage;

  if (state.isAuth) {
    return <Navigate to={from} replace={true} />;
  }

  return <>{props.children}</> ?? <Outlet />;
};

export default PublicRoute;
